import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { sendData } from '../services/auth';
import { format } from 'date-fns';
import { uriList } from '../helpers/config';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { Aguarde } from '../helpers/general';

const DashboardVendas = () => {
    const [loading, setLoading] = useState(false);
    const [dashboardData, setDashboardData] = useState(null);
    const [abaAtiva, setAbaAtiva] = useState('analise'); // 'analise' ou 'indicadores'

    // Filtros
    const [filtrarPorPeriodo, setFiltrarPorPeriodo] = useState(false);
    const [dataIni, setDataIni] = useState(null);
    const [dataFim, setDataFim] = useState(null);
    const [chavePesquisa, setChavePesquisa] = useState('');
    const [tipoPesquisa, setTipoPesquisa] = useState('vendedor');
    const [clientes, setClientes] = useState([]);
    const [colaboradores, setColaboradores] = useState([]);
    const [pessoas, setPessoas] = useState([]);
    const [data, setData] = useState({ TIPO_PESQUISA: 'vendedor' });

    const _login = useSelector((state) => state.login);
    const banco = _login.banco || 'setabd';

    const _root = process.env.REACT_APP_IP_BACKEND;
    const _port = process.env.REACT_APP_PORT_BACKEND;

    useEffect(() => {
        carregarDados();
    }, []);

    const handleChangeTipoPesquisa = (e) => {
        e.preventDefault();
        setTipoPesquisa(e.target.value);
        setData({ TIPO_PESQUISA: e.target.value });
        if (e.target.value == 'vendedor') {
            setPessoas(colaboradores);
        } else {
            setPessoas(clientes);
        }
    };

    const carregarDados = async () => {
        setLoading(true);
        console.log("DashboardVendas.carregarDados(data):", data);

        await sendData({ uri: uriList("buscarPessoas"), content: {} })
            .then((res) => {
                console.log("DashboardVendas.carregarDados(ok):", res);

                if (res.status && parseInt(res.status) > 200) throw new Error();
                else {
                    console.log("DashboardVendas.carregarDados(res.data):", res.data);
                    let _clientes = res?.filter(item => item?.CLIENTE == "SIM")
                    let _colaboradores = res?.filter(item => item?.VENDEDOR == "SIM")
                    setClientes(_clientes)
                    setColaboradores(_colaboradores)
                    setPessoas(_colaboradores)
                    console.log("DashboardVendas.carregarDados(pessoas):", _colaboradores);
                    setLoading(false);
                }
            })
            .catch((e) => {
                console.log("DashboardVendas.carregarDados(error):", e);
                setLoading(false);
                alert("Erro ao carregar dados.\n" + e.message);
            });

    };

    const handleFiltrarPorPeriodo = (checked) => {
        setFiltrarPorPeriodo(checked);
        if (checked) {
            // Define últimos 30 dias como default
            const hoje = new Date();
            const dataInicial = new Date();
            dataInicial.setDate(hoje.getDate() - 30);
            setDataIni(dataInicial);
            setDataFim(hoje);
        } else {
            setDataIni(null);
            setDataFim(null);
        }
    };

    const pesquisarDados = async () => {
        setLoading(true);
        try {
            const content = {
                banco,
                dataini: filtrarPorPeriodo && dataIni ? format(dataIni, 'yyyy-MM-dd') : null,
                datafim: filtrarPorPeriodo && dataFim ? format(dataFim, 'yyyy-MM-dd') : null,
                dados: data
            };

            console.log('Enviando dados:', content);

            const response = await sendData({
                uri: `${_root}:${_port}/dashboard/dados`,
                content
            });

            console.log('Resposta completa:', response);
            console.log('response.success:', response?.success);
            console.log('response.data:', response?.data);

            if (response?.success && response?.data) {
                console.log('Setando dashboardData com:', response.data);
                setDashboardData(response.data);
            } else {
                console.log('Condição não atendida - success:', response?.success, 'data:', response?.data);
            }
        } catch (error) {
            console.error('Erro ao buscar dados do dashboard:', error);
        } finally {
            setLoading(false);
        }
    };

    const limparFiltros = () => {
        setFiltrarPorPeriodo(false);
        setDataIni(null);
        setDataFim(null);
        setChavePesquisa('');
        setTipoPesquisa('vendedor');
        setDashboardData(null);
    };

    const formatCurrency = (value) => {
        if (!value) return 'R$ 0,00';
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(value);
    };

    const CardModerno = ({ titulo, valor, cor, icone, tipo = 'numero', tooltip = '' }) => (
        <div
            title={tooltip}
            style={{
                background: `linear-gradient(135deg, ${cor}f2 0%, ${cor} 100%)`,
                borderRadius: '12px',
                padding: '15px',
                boxShadow: `0 4px 12px ${cor}40`,
                color: '#fff',
                minHeight: '140px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                transition: 'all 0.3s ease',
                cursor: 'default',
                height: '100%',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                position: 'relative',
                overflow: 'hidden'
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px) scale(1.02)';
                e.currentTarget.style.boxShadow = `0 8px 20px ${cor}60`;
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0) scale(1)';
                e.currentTarget.style.boxShadow = `0 4px 12px ${cor}40`;
            }}>
            {/* Elemento decorativo de fundo */}
            <div style={{
                position: 'absolute',
                right: '-20px',
                bottom: '-20px',
                fontSize: '80px',
                opacity: '0.08',
                transform: 'rotate(-15deg)'
            }}>
                <i className={icone}></i>
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', position: 'relative', zIndex: 1 }}>
                <div style={{ flex: 1 }}>
                    <div style={{ fontSize: '11px', opacity: 0.95, marginBottom: '10px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                        {titulo}
                    </div>
                    <div style={{
                        fontSize: tipo === 'moeda' ? '22px' : '32px',
                        fontWeight: 'bold',
                        lineHeight: '1.1',
                        textShadow: '0 2px 4px rgba(0,0,0,0.1)'
                    }}>
                        {tipo === 'moeda' ? formatCurrency(valor) : (valor || 0)}
                    </div>
                </div>
                <div style={{
                    fontSize: '36px',
                    opacity: 0.25,
                    marginTop: '-8px',
                    marginRight: '-5px'
                }}>
                    <i className={icone}></i>
                </div>
            </div>
        </div>
    );

    return (
        <div style={{ padding: '20px', height: '100%', overflowY: 'auto', backgroundColor: '#f8f9fa' }}>
            <div style={{ marginBottom: '25px' }}>
                <h2 style={{ color: '#333', marginBottom: '5px', fontWeight: '600' }}>
                    <i className="fa fa-chart-line" style={{ marginRight: '10px', color: '#007bff' }}></i>
                    Dashboard de Vendas
                </h2>
                <p style={{ color: '#666', fontSize: '14px', margin: 0 }}>
                    Propostas e vendas
                </p>
            </div>

            {/* Filtros */}
            <div style={{
                background: '#fff',
                borderRadius: '10px',
                padding: '20px',
                marginBottom: '25px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
            }}>
                <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-end', flexWrap: 'wrap' }}>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                        <input
                            type="checkbox"
                            id="filtrarPeriodo"
                            checked={filtrarPorPeriodo}
                            onChange={(e) => handleFiltrarPorPeriodo(e.target.checked)}
                            style={{ marginRight: '8px', cursor: 'pointer' }}
                        />
                        <label htmlFor="filtrarPeriodo" style={{ fontSize: '14px', fontWeight: '600', color: '#555', cursor: 'pointer', margin: 0 }}>
                            Período
                        </label>
                    </div>
                    <div style={{ width: '120px' }}>
                        <DatePicker
                            selected={dataIni}
                            onChange={setDataIni}
                            dateFormat="dd/MM/yyyy"
                            className="form-control"
                            placeholderText="Data inicial"
                            disabled={!filtrarPorPeriodo}
                            isClearable={filtrarPorPeriodo}
                        />
                    </div>
                    <div style={{ width: '120px' }}>
                        <DatePicker
                            selected={dataFim}
                            onChange={setDataFim}
                            dateFormat="dd/MM/yyyy"
                            className="form-control"
                            placeholderText="Data final"
                            disabled={!filtrarPorPeriodo}
                            isClearable={filtrarPorPeriodo}
                        />
                    </div>
                    <div style={{ width: '300px' }}>
                        <label style={{ fontSize: '14px', fontWeight: '600', marginBottom: '8px', display: 'block', color: '#555' }}>
                            Chave de Pesquisa
                        </label>
                        <select className="form-control"
                            value={data.PESSOAID}
                            onChange={e => setData({ ...data, PESSOAID: e.target.value })} >
                            <>
                                <option value="" selected={!data.PESSOAID}>Escolha uma pessoa...</option>
                                {pessoas?.map((item, key) => {
                                    return (
                                        <option key={key} value={item.PESSOAID} selected={data.PESSOAID == item.PESSOAID}>{item.NOME + " - " + item.CNPJ_CPF}</option>
                                    )
                                })}
                            </>
                        </select>
                        {/* <input
                            type="text"
                            className="form-control"
                            placeholder="Chave de Pesquisa"
                            value={chavePesquisa}
                            onChange={(e) => setChavePesquisa(e.target.value)}
                            style={{
                                borderColor: '#ddd'
                            }}
                        /> */}
                    </div>
                    <div style={{ width: '150px' }}>
                        <label style={{ fontSize: '14px', fontWeight: '600', marginBottom: '8px', display: 'block', color: '#555' }}>
                            Tipo
                        </label>
                        <select
                            className="form-control"
                            value={tipoPesquisa}
                            onChange={handleChangeTipoPesquisa}
                            style={{
                                borderColor: '#ddd'
                            }}>
                            <option value="vendedor">Vendedor</option>
                            <option value="cliente">Cliente</option>
                        </select>
                    </div>
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <button
                            className="btn btn-primary"
                            onClick={pesquisarDados}
                            style={{
                                padding: '10px 20px',
                                borderRadius: '8px',
                                fontWeight: '600',
                                border: 'none',
                                transition: 'all 0.2s',
                                whiteSpace: 'nowrap'
                            }}>
                            <i className="fa fa-search" style={{ marginRight: '8px' }}></i>
                            Pesquisar
                        </button>
                        <button
                            className="btn btn-secondary"
                            onClick={limparFiltros}
                            style={{
                                padding: '10px 20px',
                                borderRadius: '8px',
                                fontWeight: '600',
                                border: 'none',
                                transition: 'all 0.2s',
                                whiteSpace: 'nowrap'
                            }}>
                            <i className="fa fa-eraser" style={{ marginRight: '8px' }}></i>
                            Limpar
                        </button>
                    </div>
                </div>
            </div>

            {/* Abas de Navegação */}
            {dashboardData && (
                <div style={{
                    display: 'flex',
                    gap: '10px',
                    marginBottom: '20px',
                    borderBottom: '2px solid #e0e0e0'
                }}>
                    <button
                        onClick={() => setAbaAtiva('analise')}
                        style={{
                            padding: '12px 30px',
                            background: abaAtiva === 'analise' ? 'linear-gradient(135deg, #3498db 0%, #2980b9 100%)' : '#f8f9fa',
                            color: abaAtiva === 'analise' ? '#fff' : '#555',
                            border: 'none',
                            borderBottom: abaAtiva === 'analise' ? '3px solid #2980b9' : '3px solid transparent',
                            fontWeight: '600',
                            fontSize: '14px',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            borderRadius: '8px 8px 0 0',
                            boxShadow: abaAtiva === 'analise' ? '0 -2px 8px rgba(52, 152, 219, 0.3)' : 'none'
                        }}>
                        <i className="fa fa-chart-pie" style={{ marginRight: '8px' }}></i>
                        Análise Estratégica
                    </button>
                    <button
                        onClick={() => setAbaAtiva('indicadores')}
                        style={{
                            padding: '12px 30px',
                            background: abaAtiva === 'indicadores' ? 'linear-gradient(135deg, #e67e22 0%, #d35400 100%)' : '#f8f9fa',
                            color: abaAtiva === 'indicadores' ? '#fff' : '#555',
                            border: 'none',
                            borderBottom: abaAtiva === 'indicadores' ? '3px solid #d35400' : '3px solid transparent',
                            fontWeight: '600',
                            fontSize: '14px',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            borderRadius: '8px 8px 0 0',
                            boxShadow: abaAtiva === 'indicadores' ? '0 -2px 8px rgba(230, 126, 34, 0.3)' : 'none'
                        }}>
                        <i className="fa fa-chart-area" style={{ marginRight: '8px' }}></i>
                        Indicadores de Performance
                    </button>
                </div>
            )}

            {/* Cards de Dados - Aba Análise Estratégica */}
            {dashboardData && abaAtiva === 'analise' && (
                <>
                    {/* Primeira Linha - Propostas Abertas (Agrupamento por Semelhança - Tempo) */}
                    <div style={{ marginBottom: '12px' }}>
                        <h6 style={{ color: '#555', marginBottom: '10px', fontWeight: '600', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                            <i className="fa fa-folder-open" style={{ marginRight: '8px', color: '#3498db' }}></i>
                            Propostas Abertas por Tempo
                        </h6>
                        <div className="row">
                            <div className="col-md-4 mb-2">
                                <CardModerno
                                    titulo="Últimos 30 dias"
                                    valor={dashboardData.PROPOSTAS_ABERTAS_30}
                                    cor="#2ecc71"
                                    icone="fa fa-check-circle"
                                    tooltip="Propostas abertas nos últimos 30 dias - Bom prazo para acompanhamento"
                                />
                            </div>
                            <div className="col-md-4 mb-2">
                                <CardModerno
                                    titulo="Entre 30 e 60 dias"
                                    valor={dashboardData.PROPOSTAS_ABERTAS_30_60}
                                    cor="#f39c12"
                                    icone="fa fa-clock"
                                    tooltip="Propostas abertas entre 30 e 60 dias - Atenção: requer acompanhamento próximo"
                                />
                            </div>
                            <div className="col-md-4 mb-2">
                                <CardModerno
                                    titulo="Mais de 60 dias"
                                    valor={dashboardData.PROPOSTAS_ABERTAS_60}
                                    cor="#e74c3c"
                                    icone="fa fa-exclamation-triangle"
                                    tooltip="Propostas abertas há mais de 60 dias - Urgente: risco de perda"
                                />
                            </div>
                        </div>
                    </div>

                    {/* Segunda Linha - Resultados Positivos vs Negativos (Agrupamento por Contraste) */}
                    <div style={{ marginBottom: '12px' }}>
                        <div className="row">
                            {/* Coluna Esquerda - Resultados Positivos (Tons Azuis) */}
                            <div className="col-md-6">
                                <h6 style={{ color: '#555', marginBottom: '10px', fontWeight: '600', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                    <i className="fa fa-thumbs-up" style={{ marginRight: '8px', color: '#3498db' }}></i>
                                    Faturamento Realizado
                                </h6>
                                <div className="row">
                                    <div className="col-md-6 mb-2">
                                        <CardModerno
                                            titulo="Quantidade Faturada"
                                            valor={dashboardData.PROPOSTAS_FATURADAS_QTD}
                                            cor="#3498db"
                                            icone="fa fa-file-invoice"
                                            tooltip="Número total de propostas que foram convertidas em vendas e faturadas"
                                        />
                                    </div>
                                    <div className="col-md-6 mb-2">
                                        <CardModerno
                                            titulo="Valor Total Faturado"
                                            valor={dashboardData.PROPOSTAS_FATURADAS_TOTAL}
                                            cor="#2980b9"
                                            icone="fa fa-dollar-sign"
                                            tipo="moeda"
                                            tooltip="Soma total do valor faturado de todas as propostas convertidas em vendas"
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Coluna Direita - Resultados Negativos (Tons Cinza/Vermelho) */}
                            <div className="col-md-6">
                                <h6 style={{ color: '#555', marginBottom: '10px', fontWeight: '600', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                    <i className="fa fa-times-circle" style={{ marginRight: '8px', color: '#95a5a6' }}></i>
                                    Oportunidades Perdidas
                                </h6>
                                <div className="row">
                                    <div className="col-md-6 mb-2">
                                        <CardModerno
                                            titulo="Propostas Canceladas"
                                            valor={dashboardData.PROPOSTAS_CANCELADAS_QTD}
                                            cor="#95a5a6"
                                            icone="fa fa-ban"
                                            tooltip="Número de propostas que foram canceladas e não convertidas em vendas"
                                        />
                                    </div>
                                    <div className="col-md-6 mb-2">
                                        <CardModerno
                                            titulo="Valor Não Concluído"
                                            valor={dashboardData.VENDAS_NAO_CONCLUIDAS_TOTAL}
                                            cor="#7f8c8d"
                                            icone="fa fa-money-bill-wave"
                                            tipo="moeda"
                                            tooltip="Valor total das propostas canceladas - Oportunidade de vendas perdidas"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Terceira Linha - Potencial e Performance (Agrupamento por Destaque - Tons Roxos) */}
                    <div>
                        <h6 style={{ color: '#555', marginBottom: '10px', fontWeight: '600', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                            <i className="fa fa-chart-line" style={{ marginRight: '8px', color: '#9b59b6' }}></i>
                            Análise de Potencial
                        </h6>
                        <div className="row">
                            <div className="col-md-4 mb-2">
                                <CardModerno
                                    titulo="Potencial Total"
                                    valor={dashboardData.POTENCIAL_TOTAL}
                                    cor="#9b59b6"
                                    icone="fa fa-bullseye"
                                    tipo="moeda"
                                    tooltip="Valor total do potencial de vendas possível - Meta a ser alcançada"
                                />
                            </div>
                            <div className="col-md-4 mb-2">
                                <CardModerno
                                    titulo="Potencial Atingido"
                                    valor={dashboardData.POTENCIAL_ATINGIDO}
                                    cor="#27ae60"
                                    icone="fa fa-trophy"
                                    tipo="moeda"
                                    tooltip="Valor do potencial de vendas já conquistado - Resultado alcançado"
                                />
                            </div>
                            {dashboardData.POTENCIAL_TOTAL > 0 && (
                                <div className="col-md-4 mb-2">
                                    <div style={{
                                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                        borderRadius: '12px',
                                        padding: '15px',
                                        boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)',
                                        color: '#fff',
                                        textAlign: 'center',
                                        minHeight: '140px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        border: '2px solid rgba(255, 255, 255, 0.2)'
                                    }}>
                                        <div style={{ fontSize: '12px', marginBottom: '8px', opacity: 0.9, fontWeight: '600' }}>
                                            TAXA DE CONVERSÃO
                                        </div>
                                        <div style={{ fontSize: '40px', fontWeight: 'bold', lineHeight: '1' }}>
                                            {((dashboardData.POTENCIAL_ATINGIDO / dashboardData.POTENCIAL_TOTAL) * 100).toFixed(1)}%
                                        </div>
                                        <div style={{ fontSize: '11px', marginTop: '5px', opacity: 0.85 }}>
                                            do potencial total alcançado
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </>
            )}

            {/* Aba Indicadores de Performance */}
            {dashboardData && abaAtiva === 'indicadores' && (
                <>
                    <div style={{ marginTop: '10px' }}>
                        <h5 style={{ color: '#555', marginBottom: '20px', fontWeight: '600', fontSize: '16px' }}>
                            <i className="fa fa-chart-area" style={{ marginRight: '10px', color: '#e67e22' }}></i>
                            Indicadores de Performance e Análise Estratégica
                        </h5>

                        {/* Primeira Linha - Indicadores de Eficiência */}
                        <div className="row" style={{ marginBottom: '12px' }}>
                            <div className="col-md-3 mb-2">
                                <CardModerno
                                    titulo="Ticket Médio"
                                    valor={dashboardData.PROPOSTAS_FATURADAS_QTD > 0
                                        ? dashboardData.PROPOSTAS_FATURADAS_TOTAL / dashboardData.PROPOSTAS_FATURADAS_QTD
                                        : 0}
                                    cor="#e67e22"
                                    icone="fa fa-receipt"
                                    tipo="moeda"
                                    tooltip="Valor médio por venda faturada - Indica o tamanho médio dos negócios fechados"
                                />
                            </div>
                            <div className="col-md-3 mb-2">
                                <CardModerno
                                    titulo="Taxa de Conversão"
                                    valor={((dashboardData.PROPOSTAS_FATURADAS_QTD /
                                        (dashboardData.PROPOSTAS_FATURADAS_QTD + dashboardData.PROPOSTAS_CANCELADAS_QTD +
                                            dashboardData.PROPOSTAS_ABERTAS_30 + dashboardData.PROPOSTAS_ABERTAS_30_60 +
                                            dashboardData.PROPOSTAS_ABERTAS_60)) * 100).toFixed(1) + '%'}
                                    cor="#16a085"
                                    icone="fa fa-percentage"
                                    tooltip="Percentual de propostas convertidas em vendas em relação ao total de propostas"
                                />
                            </div>
                            <div className="col-md-3 mb-2">
                                <CardModerno
                                    titulo="Taxa de Cancelamento"
                                    valor={((dashboardData.PROPOSTAS_CANCELADAS_QTD /
                                        (dashboardData.PROPOSTAS_FATURADAS_QTD + dashboardData.PROPOSTAS_CANCELADAS_QTD +
                                            dashboardData.PROPOSTAS_ABERTAS_30 + dashboardData.PROPOSTAS_ABERTAS_30_60 +
                                            dashboardData.PROPOSTAS_ABERTAS_60)) * 100).toFixed(1) + '%'}
                                    cor="#c0392b"
                                    icone="fa fa-times-circle"
                                    tooltip="Percentual de propostas canceladas - Identifica oportunidades de melhoria no processo"
                                />
                            </div>
                            <div className="col-md-3 mb-2">
                                <CardModerno
                                    titulo="Propostas em Aberto"
                                    valor={dashboardData.PROPOSTAS_ABERTAS_30 + dashboardData.PROPOSTAS_ABERTAS_30_60 + dashboardData.PROPOSTAS_ABERTAS_60}
                                    cor="#34495e"
                                    icone="fa fa-hourglass-half"
                                    tooltip="Total de propostas ainda não concluídas - Pipeline de vendas em andamento"
                                />
                            </div>
                        </div>

                        {/* Segunda Linha - Análise de Oportunidades e Risco */}
                        <div className="row" style={{ marginBottom: '12px' }}>
                            <div className="col-md-3 mb-2">
                                <CardModerno
                                    titulo="Valor Médio Perdido"
                                    valor={dashboardData.PROPOSTAS_CANCELADAS_QTD > 0
                                        ? dashboardData.VENDAS_NAO_CONCLUIDAS_TOTAL / dashboardData.PROPOSTAS_CANCELADAS_QTD
                                        : 0}
                                    cor="#e74c3c"
                                    icone="fa fa-hand-holding-usd"
                                    tipo="moeda"
                                    tooltip="Valor médio das vendas perdidas - Ajuda a dimensionar o impacto dos cancelamentos"
                                />
                            </div>
                            <div className="col-md-3 mb-2">
                                <CardModerno
                                    titulo="Gap de Meta"
                                    valor={dashboardData.POTENCIAL_TOTAL - dashboardData.POTENCIAL_ATINGIDO}
                                    cor="#d35400"
                                    icone="fa fa-crosshairs"
                                    tipo="moeda"
                                    tooltip="Diferença entre potencial total e atingido - Valor que falta para alcançar a meta"
                                />
                            </div>
                            <div className="col-md-3 mb-2">
                                <CardModerno
                                    titulo="Propostas Críticas"
                                    valor={dashboardData.PROPOSTAS_ABERTAS_60}
                                    cor="#e74c3c"
                                    icone="fa fa-exclamation-circle"
                                    tooltip="Propostas abertas há mais de 60 dias - Necessitam ação imediata para evitar perda"
                                />
                            </div>
                            <div className="col-md-3 mb-2">
                                <CardModerno
                                    titulo="Índice de Eficiência"
                                    valor={((dashboardData.PROPOSTAS_FATURADAS_TOTAL /
                                        (dashboardData.PROPOSTAS_FATURADAS_TOTAL + dashboardData.VENDAS_NAO_CONCLUIDAS_TOTAL)) * 100).toFixed(1) + '%'}
                                    cor="#27ae60"
                                    icone="fa fa-chart-line"
                                    tooltip="Percentual de faturamento em relação ao valor total de vendas (faturadas + perdidas)"
                                />
                            </div>
                        </div>

                        {/* Terceira Linha - Projeções e Tendências */}
                        <div className="row">
                            <div className="col-md-4 mb-2">
                                <CardModerno
                                    titulo="Potencial em Risco"
                                    valor={((dashboardData.PROPOSTAS_ABERTAS_60 /
                                        (dashboardData.PROPOSTAS_ABERTAS_30 + dashboardData.PROPOSTAS_ABERTAS_30_60 +
                                            dashboardData.PROPOSTAS_ABERTAS_60)) * 100).toFixed(1) + '%'}
                                    cor="#c0392b"
                                    icone="fa fa-shield-alt"
                                    tooltip="Percentual de propostas críticas (>60 dias) em relação ao total em aberto"
                                />
                            </div>
                            <div className="col-md-4 mb-2">
                                <CardModerno
                                    titulo="Performance vs Meta"
                                    valor={((dashboardData.POTENCIAL_ATINGIDO / dashboardData.POTENCIAL_TOTAL) * 100).toFixed(1) + '%'}
                                    cor={((dashboardData.POTENCIAL_ATINGIDO / dashboardData.POTENCIAL_TOTAL) * 100) >= 80 ? '#27ae60' :
                                        ((dashboardData.POTENCIAL_ATINGIDO / dashboardData.POTENCIAL_TOTAL) * 100) >= 50 ? '#f39c12' : '#e74c3c'}
                                    icone="fa fa-target"
                                    tooltip="Percentual de meta alcançada - Verde: ≥80% | Amarelo: ≥50% | Vermelho: <50%"
                                />
                            </div>
                            <div className="col-md-4 mb-2">
                                <CardModerno
                                    titulo="Valor Total em Jogo"
                                    valor={dashboardData.PROPOSTAS_FATURADAS_TOTAL + dashboardData.VENDAS_NAO_CONCLUIDAS_TOTAL +
                                        (dashboardData.POTENCIAL_TOTAL - dashboardData.POTENCIAL_ATINGIDO)}
                                    cor="#8e44ad"
                                    icone="fa fa-coins"
                                    tipo="moeda"
                                    tooltip="Soma de faturado + perdido + gap de meta - Movimentação total do período"
                                />
                            </div>
                        </div>
                    </div>
                </>
            )}

            {!dashboardData && !loading && (
                <div style={{
                    textAlign: 'center',
                    padding: '60px 20px',
                    background: '#fff',
                    borderRadius: '10px',
                    color: '#999'
                }}>
                    <i className="fa fa-chart-line" style={{ fontSize: '80px', marginBottom: '20px', opacity: 0.3 }}></i>
                    <h4 style={{ color: '#666' }}>Utilize os filtros acima para visualizar os dados</h4>
                    <p>Selecione o período, vendedor ou cliente e clique em Pesquisar</p>
                </div>
            )}

            {loading && <Aguarde legenda="Carregando dados do dashboard..." />}
        </div>
    );
};

export default DashboardVendas;
